import React, { useEffect, useState } from 'react';
import { useApiClient } from '../../service/API';
import useDebounced from '../../hooks/useDebounced';
import Pill from './Pill';

export default function StageSearch({ onPick, onCreateNew }) {
  const apiClient = useApiClient();
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const qDebounced = useDebounced(query, 350);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      try {
        const res = await apiClient.get(`/config/service-flow/stage-catalog?q=${encodeURIComponent(qDebounced)}`);
        if (alive) setResults(res.data || []);
      } catch {
        if (alive) setResults([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [qDebounced]);

  return (
    <div>
      <div className="sfm-search-container">
        <input
          className="sfm-search-input"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          type="search"
          placeholder="Search existing stages…"
        />
      </div>
      <div className="sfm-search-results">
        {loading ? (
          <div className="p-3">Searching…</div>
        ) : (
          <ul>
            {results.map((r) => (
              <li key={r.id} onClick={() => onPick(r)}>
                <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                  <div>
                    <div style={{fontWeight:600, fontSize:14}}>{r.name}</div>
                    <div style={{opacity:0.7, fontSize:12}}>{r.code}</div>
                  </div>
                  <Pill>Stage</Pill>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Add brand-new stage */}
      <div style={{display:'flex', gap:8, marginTop:8}}>
        <input className="sfm-search-input" placeholder="New stage name…" id="newStageName"/>
        <button
          className="sfm-btn sfm-btn-secondary"
          onClick={()=>{
            const el = document.getElementById('newStageName');
            const name = (el?.value || '').trim();
            if (!name) return;
            onCreateNew(name);
            el.value = '';
          }}
        >
          Add Stage
        </button>
      </div>
      <p style={{fontSize:12, marginTop:6}}>
        New stages are created as <b>non-terminal</b> by default. Only <b>Booking Creation</b> and <b>Ticket Closed</b> are saved as terminal.
      </p>
    </div>
  );
}
